import { Field, Mutation, Query } from '@tilework/opus';

import { MyAccountQuery as SourceMyAccountQuery } from 'SourceQuery/MyAccount.query';
import {CustomerDeliveryDate, CustomerFieldsTotal} from 'SourceQuery/MyAccount.type';

import {
    CustomerFieldsMerged,
} from './MyAccount.type';

/** @namespace Steinkrueger/Query/CustomerDeliveryDate/Query */
export class CustomerDeliveryDateQuery extends SourceMyAccountQuery {
    getCustomerDeliveryDate(): Query<'customer', CustomerDeliveryDate> {
        return new Query<'customer', CustomerDeliveryDate>('customer')
            .addFieldList(this._getCustomerDeliveryDate());
    }

    setCustomerDeliveryDateMutation(options: { deliveryDate: string }): Mutation<
    'setCustomerDeliveryDate', { status: string }> {
        const { deliveryDate } = options;

        return new Mutation<'setCustomerDeliveryDate', { status: string }>('setCustomerDeliveryDate')
            .addArgument('deliveryDate', 'String!', deliveryDate)
            .addFieldList(this._updateCustomerDeliveryDate());
    }

    _updateCustomerDeliveryDate(): CustomerFieldsTotal<CustomerFieldsMerged> {
        return [
            this._updateDeliveryDateField(),
        ];
    }

    _getCustomerDeliveryDate(): CustomerFieldsTotal<CustomerFieldsMerged> {
        return [
            this._getDeliveryDateField(),
        ];
    }

    _getDeliveryDateField(): Field<'delivery_date', string> {
        return new Field<'delivery_date', string>('delivery_date', false);
    }

    _updateDeliveryDateField(): Field<'deliveryDate', string> {
        return new Field<'deliveryDate', string>('deliveryDate', false);
    }
}

export default new CustomerDeliveryDateQuery();
